import Component from "@glimmer/component"
import MonthLessonTitleIsland from "react-app/islands/MonthLessonTitleIsland"

interface Signature {
  Args: {
    courseId: string
    planbookId: string
    rotationCalendarId: string
    dateString: string
    /** `weekIndex.courseIndex` — the month grid's row-height bookkeeping key. */
    gridIndex: string
    recalcHeights?: (gridIndex: string) => void
    onLessonFocus?: () => void
  }
}

export default class MonthLessonTitleIslandBridge extends Component<Signature> {
  readonly MonthLessonTitleIsland = MonthLessonTitleIsland
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Bridges::MonthLessonTitleIslandBridge": typeof MonthLessonTitleIslandBridge
  }
}
